module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_3.6975b18e.png";